import { render, staticRenderFns } from "./dataReport.vue?vue&type=template&id=75b826a2&scoped=true"
import script from "./dataReport.vue?vue&type=script&lang=ts"
export * from "./dataReport.vue?vue&type=script&lang=ts"
import style0 from "./dataReport.vue?vue&type=style&index=0&id=75b826a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b826a2",
  null
  
)

export default component.exports